import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReportRunnerComponent } from '../../components/report-runner/report-runner.component';

@Component({
  selector: 'app-outcomes-report',
  imports: [ReportRunnerComponent],
  templateUrl: './outcomes-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutcomesReportComponent {}
